import { defineStore } from 'pinia'
import axios from 'axios'
import { useAuthStore } from '@/auth/auth'
import { ApiSup } from "@/Functions/ApiSupport";
import { th } from 'date-fns/locale';


export const usedStudentStore = defineStore('studentsStore', {
  state: () => ({
    students: [],
    student: {},
    studentCount: 0,
  }),
  getters: {
    getStaffById: (state) => (id) => {
      return state.students.find((staff) => staff.id === id) || null
    },
  },
  actions: {
    async addStudent(bodyx) {
      try {
    // console.log(JSON.stringify(bodyx))

        const authStore = useAuthStore()
        // const res = await fetch('http://localhost:8080/api/students/', {
        const res = await fetch(`${import.meta.env.VITE_HOST_API}/api/students/`, {
          method: 'POST',
          body: bodyx,
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${authStore.token}`,
          },
        })
        const data = await res.json()
        // console.log(JSON.stringify(data))
        if (!res.ok) {
          console.error('Server error:', data)
          return { success: false, error: data }
        }
        this.fetchData()
        if (data.status === 'success'){
        return { success: true, data }

        }else{
          return { success: false, error: data }

        }
      } catch (err) {
        console.error('Network error:', err)
        return { success: false, error: err }
      }
    },

    async fetchData() {
      const authStore = useAuthStore()
      //const res = await fetch('http://localhost:8080/api/students/')
      const res = await fetch(`${import.meta.env.VITE_HOST_API}/api/students/`, {
        headers: {
          Authorization: `Bearer ${authStore.token}`,
        },
      })
      const data = await res.json()
      this.students = data.data
    },
    async fetchDataBySchool(pid) {
      const authStore = useAuthStore()
      const res = await fetch(`${import.meta.env.VITE_HOST_API}/api/schools/` + pid + `/students`, {
        headers: {
          Authorization: `Bearer ${authStore.token}`,
        },
      })
      const data = await res.json()
      this.students = data.data

      this.studentCount = data.count
    },

    async fetchDataByID(pid) {
      const authStore = useAuthStore()
      //const res = await fetch('http://localhost:8080/api/students/' + pid)
      const res = await fetch(`${import.meta.env.VITE_HOST_API}/api/students/` + pid, {
        headers: {
          Authorization: `Bearer ${authStore.token}`,
        },
      })
      const data = await res.json()
      this.student = data.data
    },
    async fetchByParentID(pid){
      const authStore = useAuthStore()
      //const res = await fetch('http://localhost:8080/api/students/' + pid)
      const res = await fetch(`${import.meta.env.VITE_HOST_API}/api/students/getStudentByParent/` + pid, {
        headers: {
          Authorization: `Bearer ${authStore.token}`,
        },
      })
      const data = await res.json()
      this.students = data.student
      this.studentCount = data.count

    },

    async updateStudent(body, pid){
              const apiSup = ApiSup()
              const ret = await apiSup.putSupport('api/students/' + pid, body)
              this.fetchDataByID(pid)
                  if (ret === 'Success'){
                    return { success : true}
                  }else{
                    return { success: false, data: ret.response.data.message }
                  }
    }
  },
})
